import { toQuotedString, createIssuesUrl } from '@atlassian/jira-common-jql/src/helpers.tsx';
import { calculateTotalPages } from '@atlassian/jira-common-pagination/src/index.tsx';
import {
	getName as getComponentName,
	getComponent,
	getTotalItems,
} from './components/selectors.tsx';
import { getProjectKey } from './project/selectors.tsx';
import type { State } from './reducer.tsx';
import { getItemsOnPage } from './ui/page/selectors.tsx';

export const getTotalPages = (state: State): number =>
	calculateTotalPages(getTotalItems(state), getItemsOnPage(state));

export const getIssuesUrl = (state: State, componentId: string): string => {
	if (!getComponent(state, componentId)) {
		return '';
	}

	const projectKey = getProjectKey(state);
	const componentName = getComponentName(state, componentId);
	const jql = `project = ${toQuotedString(projectKey)} AND component = ${toQuotedString(
		componentName,
	)}`;

	return createIssuesUrl(jql);
};
